import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from '@chakra-ui/react';

const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    siteName,
    isDeleting,
}) => (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader>Delete Site</ModalHeader>
            <ModalBody>
                <Text>
                    Are you sure you want to delete <strong>{siteName}</strong>?
                    This action cannot be undone.
                </Text>
            </ModalBody>
            <ModalFooter gap={3}>
                <Button
                    variant="outline"
                    onClick={onClose}
                    isDisabled={isDeleting}>
                    Cancel
                </Button>
                <Button
                    colorScheme="red"
                    onClick={onConfirm}
                    isLoading={isDeleting}
                    loadingText="Deleting">
                    Delete
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default DeleteConfirmationModal;
